import { render, staticRenderFns } from "./stock-info.vue?vue&type=template&id=b74c555e&scoped=true&lang=pug&"
import script from "./stock-info.vue?vue&type=script&lang=js&"
export * from "./stock-info.vue?vue&type=script&lang=js&"
import style0 from "./stock-info.vue?vue&type=style&index=0&id=b74c555e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74c555e",
  null
  
)

export default component.exports